import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FullComponent } from './full/full.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './login/login.component';
import { LookerDashboard } from './looker-dashboard/looker-dashboard';
import { OpportunityComponent } from './opportunity/opportunity.component';
import { TemplateSelectorComponent } from './template-selector/template-selector.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', redirectTo: '/landing', pathMatch: 'full' },
      {
        path: 'landing',
        component: TemplateSelectorComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'portfolio', 'sales'] }
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'portfolio', 'sales'] }
      },
      {
        path: 'report',
        component: LookerDashboard,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'portfolio'] }
      },
      {
        path: 'opportunity',
        component: OpportunityComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'portfolio', 'sales'] }
      },

      {
        path: 'unauthorized', component: UnauthorizedComponent, canActivate: [AuthGuard],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
